import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface NavigationContext {
  type: "MyProject" | "Workspace" | "Team" | "ClimateAction";
  id: string;
}

type ProjectNavigationStore = {
  projectIdList: string[];
  setProjectIdList: (projectIdList: string[]) => void;
  navigationContext: NavigationContext | null;
  setNavigationContext: (navigationContext: NavigationContext | null) => void;
};

export const useProjectNavigationStore = create<ProjectNavigationStore>()(
  persist(
    (set) => ({
      projectIdList: [],
      setProjectIdList: (projectIdList: string[]) => {
        set((state) => ({
          ...state,
          projectIdList,
        }));
      },
      navigationContext: {
        type: "Workspace",
        id: "",
      },
      setNavigationContext: (navigationContext: NavigationContext | null) => {
        set((state) => ({
          ...state,
          navigationContext,
        }));
      },
    }),
    {
      name: "project-navigation", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export const getProjectNavigationPath = (navigationContext: NavigationContext | null): string => {
  if (!navigationContext) return "projects";

  switch (navigationContext.type) {
    case "MyProject":
      return "my-projects";
    case "Workspace":
      return "projects";
    case "Team":
      return "teams";
    case "ClimateAction":
      return "climate-actions";
    default:
      return "projects";
  }
};
